import { Navigate, Outlet } from "react-router-dom";
import { getAuthToken } from "../../utils/helpers/auth";

export const PublicRoute = () => {
  return getAuthToken() ? <Navigate to={"/dashboard"} /> : <Outlet />;
};
